import * as React from "react";

const State = () => {
  return (
    <ol className="references">
      <li>
        Centers for Disease Control and Prevention. MMWR Weekly:{" "}
        <i>pneumocystis</i> pneumonia—Los Angeles.{" "}
        <i>MMWR Morb Mortal Wkly Rep.</i> 1981;30(21):1-3. Accessed July 30,
        2021.&nbsp;
        <br className="d-block d-md-none" />
        <a
          target="_blank"
          href="https://www.cdc.gov/mmwr/preview/mmwrhtml/june_5.htm"
        >
          https://www.cdc.gov/mmwr/preview/mmwrhtml/june_5.htm
        </a>
      </li>
      <li>
        Centers for Disease Control and Prevention. Update: mortality
        attributable to HIV infection among persons aged 25-44 Years—United
        States, 1991 and 1992. <i>MMWR Morb Mortal Wkly Rep.</i>{" "}
        1993;42(45):869-872. Accessed July 30, 2021.
        <br />
        <a
          target="_blank"
          href="https://www.cdc.gov/mmwr/preview/mmwrhtml/00022174.htm"
        >
          https://www.cdc.gov/mmwr/preview/mmwrhtml/00022174.htm
        </a>
      </li>
      <li>
        Centers for Disease Control and Prevention. CDC fact sheet: proven HIV
        prevention methods. May 2016. Accessed July 30, 2021.
        <br />
        <a
          target="_blank"
          href="https://www.cdc.gov/nchhstp/newsroom/docs/factsheets/hiv-proven-prevention-methods-508.pdf"
        >
          https://www.cdc.gov/nchhstp/newsroom/docs/factsheets/hiv-proven-prevention-methods-508.pdf
        </a>
      </li>
      <li>
        Kaiser Family Foundation. The HIV AIDS epidemic in the US: the basics.
        June 7, 2021. Accessed July 30, 2021.
        <br />
        <a
          target="_blank"
          href="https://www.kff.org/hivaids/fact-sheet/the-hivaids-epidemic-in-the-united-states-the-basics/"
        >
          https://www.kff.org/hivaids/fact-sheet/the-hivaids-epidemic-in-the-united-states-the-basics/
        </a>
      </li>
      <li>
        National Institute of Allergy and Infectious Diseases. HIV cure. Updated
        March 26, 2019. Accessed July 30, 2021.
        <br />
        <a
          target="_blank"
          href="https://www.niaid.nih.gov/diseases-conditions/hiv-cure-research"
        >
          https://www.niaid.nih.gov/diseases-conditions/hiv-cure-research
        </a>
      </li>
      <li>
        Centers for Disease Control and Prevention. Estimated annual number of
        HIV infections—United States, 1981–2019.{" "}
        <i>MMWR Morb Mortal Wkly Rep.</i> 2021;70:801-806.
      </li>

      <li>
        Centers for Disease Control and Prevention. CDC fact sheet: HIV in the
        United States and Dependent Areas. July 2021. Accessed August 25, 2021.
        <br />
        <a
          target="_blank"
          href="https://www.cdc.gov/hiv/pdf/statistics/overview/cdc-hiv-us-ataglance.pdf"
        >
          https://www.cdc.gov/hiv/pdf/statistics/overview/cdc-hiv-us-ataglance.pdf
        </a>
      </li>

      <li>
        Huang YA, Zhu W, Smith DK, Harris N, Hoover KW. HIV preexposure
        prophylaxis, by race and ethnicity—United States, 2014&ndash;2016.{" "}
        <i>MMWR Morb Mortal Wkly Rep.</i> 2018;67(41):1147-1150.
      </li>
      <li>
        Centers for Disease Control and Prevention. Estimated HIV incidence and
        prevalence in the United States, 2015–2019.{" "}
        <i>HIV Surveillance Supplemental Report.</i> 2021;26(1). Published May
        2021. Accessed July 30, 2021.
        <br />
        <a
          target="_blank"
          href="https://www.cdc.gov/hiv/pdf/library/reports/surveillance/cdc-hiv-surveillance-supplemental-report-vol-26-1.pdf"
        >
          https://www.cdc.gov/hiv/pdf/library/reports/surveillance/cdc-hiv-surveillance-supplemental-report-vol-26-1.pdf
        </a>
      </li>
      <li>
        Centers for Disease Control and Prevention. Monitoring selected national
        HIV prevention and care objectives by using surveillance data—United
        States and 6 dependent areas, 2019.{" "}
        <i>HIV Surveillance Supplemental Report.</i> 2021;26(2). Published May
        2021. Accessed July 30, 2021.&nbsp;
        <br className="d-block d-md-none" />
        <a
          target="_blank"
          href="https://www.cdc.gov/hiv/pdf/library/reports/surveillance/cdc-hiv-surveillance-report-vol-26-no-2.pdf"
        >
          https://www.cdc.gov/hiv/pdf/library/reports/surveillance/cdc-hiv-surveillance-report-vol-26-no-2.pdf
        </a>
      </li>
      <li>
        Kaiser Family Foundation. Disparities in health and health care: 5 key
        questions and answers. May 11, 2021. Accessed July 30, 2021.
        <br />
        <a
          target="_blank"
          href="https://www.kff.org/racial-equity-and-health-policy/issue-brief/disparities-in-health-and-health-care-5-key-question-and-answers/"
        >
          https://www.kff.org/racial-equity-and-health-policy/issue-brief/disparities-in-health-and-health-care-5-key-question-and-answers/
        </a>
      </li>
      <li>
        Centers for Disease Control and Prevention. HIV treatment. Updated May
        20, 2021. Accessed July 30, 2021.
        <br />
        <a
          target="_blank"
          href="https://www.cdc.gov/hiv/basics/livingwithhiv/treatment.html"
        >
          https://www.cdc.gov/hiv/basics/livingwithhiv/treatment.html
        </a>
      </li>
      <li>
        Centers for Disease Control and Prevention. HIV and gay and bisexual
        men. Updated September 16, 2020. Accessed July 30, 2021.
        <br />
        <a target="_blank" href="https://www.cdc.gov/hiv/group/msm/index.html">
          https://www.cdc.gov/hiv/group/msm/index.html
        </a>
      </li>
      <li>
        Hess KL, Hu X, Lansky A, Mermin J, Hall HI. Lifetime risk of a diagnosis
        of HIV infection in the United States. <i>Ann Epidemiol.</i>{" "}
        2017;27(4):238-243.
      </li>
      <li>
        Avert. HIV and AIDS in the United States of America (USA). Updated June
        23, 2021. Accessed July 30, 2021.
        <br />
        <a
          target="_blank"
          href="https://www.avert.org/professionals/hiv-around-world/western-central-europe-north-america/usa#footnoteref13_w5i5o95"
        >
          https://www.avert.org/professionals/hiv-around-world/western-central-europe-north-america/usa#footnoteref13_w5i5o95
        </a>
      </li>
      <li>
        Centers for Disease Control and Prevention. Diagnoses of HIV infection
        in the United States and dependent areas, 2019.{" "}
        <i>HIV Surveillance Report.</i> 2019;32. Published May 2021. Accessed
        July 30, 2021.
        <br />
        <a
          target="_blank"
          href="https://www.cdc.gov/hiv/pdf/library/reports/surveillance/cdc-hiv-surveillance-report-2018-updated-vol-32.pdf"
        >
          https://www.cdc.gov/hiv/pdf/library/reports/surveillance/cdc-hiv-surveillance-report-2018-updated-vol-32.pdf
        </a>
      </li>
      <li>
        Centers for Disease Control and Prevention. HIV and African American
        people. Updated January 20, 2021. Accessed July 30, 2021.
        <br />
        <a
          target="_blank"
          href="https://www.cdc.gov/hiv/group/racialethnic/africanamericans/index.html"
        >
          https://www.cdc.gov/hiv/group/racialethnic/africanamericans/index.html
        </a>
      </li>
      <li>
        Centers for Disease Control and Prevention. HIV and Hispanics/Latinos.
        Updated March 18, 2021. Accessed July 30, 2021.
        <br />
        <a
          target="_blank"
          href="https://www.cdc.gov/hiv/group/racialethnic/hispaniclatinos/index.html"
        >
          https://www.cdc.gov/hiv/group/racialethnic/hispaniclatinos/index.html
        </a>
      </li>
      <li>
        Kaiser Family Foundation. Hispanic people are facing widening gaps in
        health coverage. November 6, 2020. Accessed July 30, 2021.
        <br />
        <a
          target="_blank"
          href="https://www.kff.org/policy-watch/hispanic-people-facing-widening-gaps-health-coverage/"
        >
          https://www.kff.org/policy-watch/hispanic-people-facing-widening-gaps-health-coverage/
        </a>
      </li>
      <li>
        United States Census Bureau. Hispanic population to reach 111 million by
        2060. October 9, 2018. Accessed July 30, 2021.
        <br />
        <a
          target="_blank"
          href="https://www.census.gov/library/visualizations/2018/comm/hispanic-projected-pop.html"
        >
          https://www.census.gov/library/visualizations/2018/comm/hispanic-projected-pop.html
        </a>
      </li>
      <li>
        Centers for Disease Control and Prevention. HIV infection risk,
        prevention, and testing behaviors among men who have sex with
        men—National HIV Behavioral Surveillance, 23 U.S. Cities, 2017.{" "}
        <i>HIV Surveillance Special Report.</i> 2019;22. Published February
        2019. Accessed July 30, 2021.&nbsp;
        <br className="d-block d-md-none" />
        <a
          target="_blank"
          href="https://www.cdc.gov/hiv/pdf/library/reports/surveillance/cdc-hiv-surveillance-special-report-number-22.pdf"
        >
          https://www.cdc.gov/hiv/pdf/library/reports/surveillance/cdc-hiv-surveillance-special-report-number-22.pdf
        </a>
      </li>
      <li>
        Avert. Transgender people, HIV and AIDS. Updated April 4, 2017. Accessed
        July 30, 2021.
        <br />
        <a
          target="_blank"
          href="https://www.avert.org/professionals/hiv-social-issues/key-affected-populations/transgender"
        >
          https://www.avert.org/professionals/hiv-social-issues/key-affected-populations/transgender
        </a>
      </li>
      <li>
        Human Rights Campaign. Transgender people and HIV: what we know.
        Published 2020. Accessed July 30, 2021.
        <br />
        <a
          target="_blank"
          href="https://www.hrc.org/resources/transgender-people-and-hiv-what-we-know"
        >
          https://www.hrc.org/resources/transgender-people-and-hiv-what-we-know
        </a>
      </li>
      <li>
        James SE, Herman JL, Rankin S, et al. The report of the 2015 U.S.
        Transgender Survey. National Center for Transgender Equality. Published
        December 2017. Accessed July 30, 2021.&nbsp;
        <br className="d-block d-md-none" />
        <a
          target="_blank"
          href="https://transequality.org/sites/default/files/docs/usts/USTS-Full-Report-Dec17.pdf"
        >
          https://transequality.org/sites/default/files/docs/usts/USTS-Full-Report-Dec17.pdf
        </a>
      </li>
      <li>
        Centers for Disease Control and Prevention. HIV and transgender people:
        HIV diagnoses. Updated July 14, 2021. Accessed July 30, 2021.
        <br />
        <a
          target="_blank"
          href="https://www.cdc.gov/hiv/group/gender/transgender/hiv-diagnoses.html"
        >
          https://www.cdc.gov/hiv/group/gender/transgender/hiv-diagnoses.html
        </a>
      </li>
      <li>
        Centers for Disease Control and Prevention. HIV infection, risk,
        prevention, and testing behaviors among transgender women—National HIV
        Behavioral Surveillance, 7 U.S. Cities, 2019–2020.{" "}
        <i>HIV Surveillance Special Report.</i> 2021;27. Published April 2021.
        Accessed July 30, 2021.&nbsp;
        <br className="d-block d-md-none" />
        <a
          target="_blank"
          href="https://www.cdc.gov/hiv/pdf/library/reports/surveillance/cdc-hiv-surveillance-special-report-number-27.pdf"
        >
          https://www.cdc.gov/hiv/pdf/library/reports/surveillance/cdc-hiv-surveillance-special-report-number-27.pdf
        </a>
      </li>
      <li>
        Baral SD, Poteat T, Strömdahl S, et al. Worldwide burden of HIV in
        transgender women: a systematic review and meta-analysis.{" "}
        <i>Lancet Infect Dis.</i> 2013;13:214-222.
      </li>
      <li>
        Kaiser Family Foundation. Women and HIV in the United States. March 9,
        2020. Accessed July 30, 2021.
        <br />
        <a
          target="_blank"
          href="https://www.kff.org/hivaids/fact-sheet/women-and-hivaids-in-the-united-states/"
        >
          https://www.kff.org/hivaids/fact-sheet/women-and-hivaids-in-the-united-states/
        </a>
      </li>
      <li>
        Avert. Women and girls, HIV and AIDS. Updated April 23, 2020. Accessed
        July 30, 2021.
        <br />
        <a
          target="_blank"
          href="https://www.avert.org/professionals/hiv-social-issues/key-affected-populations/women"
        >
          https://www.avert.org/professionals/hiv-social-issues/key-affected-populations/women
        </a>
      </li>
      <li>
        Higgins JA, Hoffman S, Dworkin SL. Rethinking gender, heterosexual men,
        and women’s vulnerability to HIV/AIDS. <em>Am J Public Health.</em>{" "}
        2010;100(3):435-445.
      </li>
      <li>
        Centers for Disease Control and Prevention. HIV and women. Published
        March 2021. Accessed July 30, 2021.
        <br />
        <a
          target="_blank"
          href="https://www.cdc.gov/hiv/pdf/group/gender/women/cdc-hiv-women.pdf"
        >
          https://www.cdc.gov/hiv/pdf/group/gender/women/cdc-hiv-women.pdf
        </a>
      </li>
      <li>
        Centers for Disease Control and Prevention. HIV and women: PrEP
        coverage. Updated March 8, 2021. Accessed July 30, 2021.
        <br />
        <a
          target="_blank"
          href="https://www.cdc.gov/hiv/group/gender/women/prep-coverage.html"
        >
          https://www.cdc.gov/hiv/group/gender/women/prep-coverage.html
        </a>
      </li>
      <li>
        Centers for Disease Control and Prevention. HIV and youth. Published May
        2021. Accessed July 30, 2021.
        <br />
        <a
          target="_blank"
          href="https://www.cdc.gov/hiv/pdf/group/age/youth/cdc-hiv-youth.pdf"
        >
          https://www.cdc.gov/hiv/pdf/group/age/youth/cdc-hiv-youth.pdf
        </a>
      </li>
      <li>
        Centers for Disease Control and Prevention. HIV and youth: HIV risk
        behaviors. Updated July 2, 2021. Accessed July 30, 2021.
        <br />
        <a
          target="_blank"
          href="https://www.cdc.gov/hiv/group/age/youth/risk-behaviors.html"
        >
          https://www.cdc.gov/hiv/group/age/youth/risk-behaviors.html
        </a>
      </li>
      <li>
        Satterwhite CL, Torrone E, Meites E, et al. Sexually transmitted
        infections among US women and men: prevalence and incidence estimates,
        2008. <i>Sex Transm Dis.</i> 2013;40(3):187-193.
      </li>
      <li>
        Centers for Disease Control and Prevention. STDs and HIV – CDC fact
        sheet. Updated March 5, 2021. Accessed July 30, 2021.
        <br />
        <a
          target="_blank"
          href="https://www.cdc.gov/std/hiv/stdfact-std-hiv.htm"
        >
          https://www.cdc.gov/std/hiv/stdfact-std-hiv.htm
        </a>
      </li>
      <li>
        Centers for Disease Control and Prevention. STDs in adolescents and
        young adults. Updated July 30, 2019. Accessed July 30, 2021.
        <br />
        <a
          target="_blank"
          href="https://www.cdc.gov/std/stats18/adolescents.htm"
        >
          https://www.cdc.gov/std/stats18/adolescents.htm
        </a>
      </li>
      <li>
        Centers for Disease Control and Prevention. HIV and youth: PrEP
        coverage. Updated July 2, 2021. Accessed July 30, 2021.
        <br />
        <a
          target="_blank"
          href="https://www.cdc.gov/hiv/group/age/youth/prep-coverage.html"
        >
          https://www.cdc.gov/hiv/group/age/youth/prep-coverage.html
        </a>
      </li>
      <li>
        Centers for Disease Control and Prevention. HIV in the southern United
        States. Published September 2019. Accessed July 30, 2021.
        <br />
        <a
          target="_blank"
          href="https://www.cdc.gov/hiv/pdf/policies/cdc-hiv-in-the-south-issue-brief.pdf"
        >
          https://www.cdc.gov/hiv/pdf/policies/cdc-hiv-in-the-south-issue-brief.pdf
        </a>
      </li>
      <li>
        Reif S, Safley D, McAllaster C, Wilson E, Whetten K. State of HIV in the
        US deep south. <i>J Community Health.</i> 2017;42(5):844-853.
      </li>
      <li>
        Centers for Disease Control and Prevention. Diagnoses of HIV infection
        in the United States and dependent areas, 2017.{" "}
        <i>HIV Surveillance Report.</i> 2017;29. Published November 2018.
        Accessed July 30, 2021.
        <br />
        <a
          target="_blank"
          href="https://www.cdc.gov/hiv/pdf/library/reports/surveillance/cdc-hiv-surveillance-report-2017-vol-29.pdf"
        >
          https://www.cdc.gov/hiv/pdf/library/reports/surveillance/cdc-hiv-surveillance-report-2017-vol-29.pdf
        </a>
      </li>
      <li>
        AIDSVu.org. HIV in the southern US: 2018 regional data. Accessed July
        30, 2021.&nbsp;
        <br className="d-block d-md-none" />
        <a
          target="_blank"
          href="https://aidsvu.org/local-data/united-states/south/"
        >
          https://aidsvu.org/local-data/united-states/south/
        </a>
      </li>
      <li>
        National Institute of Allergy and Infectious Diseases. HIV/AIDS. Updated
        June 29, 2020. Accessed July 30, 2021.
        <br />
        <a
          target="_blank"
          href="https://www.niaid.nih.gov/diseases-conditions/hivaids"
        >
          https://www.niaid.nih.gov/diseases-conditions/hivaids
        </a>
      </li>
    </ol>
  );
};

export default State;
